export default __webpack_public_path__ + "static/media/three.1ee9cd3a.jpg";